import { ThumbsDownIcon } from '../../icons/ThumbsDownIcon'

export interface DislikeButtonProps {
  value: number
  active?: boolean
  onClick: () => void
}

export function DislikeButton({ value, active, onClick }: DislikeButtonProps) {
  return (
    <button
      className={`button-svg button-impression ${
        active ? 'button-impression--negative-active' : ''
      }`}
      onClick={onClick}
      aria-label='dislike'
    >
      <ThumbsDownIcon />
      <span>{value}</span>
    </button>
  )
}
